interface MedicalCardProps {
  height?: string;
  width?: string;
  fillColor?: string;
}

const MedicalCard = (props: MedicalCardProps) => {
  return (
    <svg
      width={props.width || "64px"}
      height={props.height || "64px"}
      viewBox="0 0 16 16"
      version="1.1"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          fill={props.fillColor || "#000000"}
          d="M15 3v10h-14v-10h14zM16 2h-16v12h16v-12z"
        ></path>{" "}
        <path fill="#444" d="M9 5h5v1h-5v-1z"></path>{" "}
        <path fill="#444" d="M9 7h5v1h-5v-1z"></path>{" "}
        <path fill="#444" d="M9 9h2v1h-2v-1z"></path>{" "}
        <path
          fill={props.fillColor || "#000000"}
          d="M6.5 5c0 0 0 0 0 0-0.6 0-1.1 0.6-1.5 1-0.4-0.4-0.9-1-1.5-1 0 0 0 0 0 0-1.5 0-2.1 1.9-1 2.9l2.5 2.1 2.5-2.1c1.1-1 0.5-2.9-1-2.9z"
        ></path>{" "}
      </g>
    </svg>
  );
};

export default MedicalCard;
